import React, { Component } from 'react';

import {
    Select, Row, Col, Button, Form,
} from 'antd';

import Custom from '../DoseFrequencyHelper/Custom';
import CustomMonth from '../DoseFrequencyHelper/CustomMonth';

const { Option } = Select;
const FormItem = Form.Item;

class UnwrappedDoseFrequency extends Component {
    state = {
        frequency: '',
    }

    handleChange = (value) => {
        this.setState({ frequency: value });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { form, handleDoseFrequency, changeActiveKey } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            // console.log('Received values of form: ', values);
            handleDoseFrequency(values);
            changeActiveKey('4');
            // console.log(this.state.value);
        });
    }

    render() {
        const {
            form, data, selectedMed, changeActiveKey, handleDoseFrequency,
        } = this.props;

        const { getFieldDecorator, getFieldValue } = form;

        const { frequency } = data;

        const medName = selectedMed.split('#')[1];

        const frequencies = [
            { key: 1, value: 'Every Day' }, { key: 2, value: 'Every Second Day' }, { key: 3, value: 'Every Third Day' }, { key: 7, value: 'Every Week' },
            { key: 14, value: 'Every Second Week' }, { key: 30, value: 'Every Month' }, { key: 0, value: 'Custom' },
        ];

        const frequencyOptions = frequencies.map(freq => (<Option key={freq.key} value={freq.key}>{freq.value}</Option>));

        return (
            <div style={{
                height: '500px', overflow: 'auto', margin: 'auto', paddingTop: '5%', textAlign: 'center',
            }}
            >

                <h5 style={{ textAlign: 'center' }}>{medName}</h5>
                {/* <div style={{ height: '300px', overflow: 'auto', textAlign: 'center' }}> */}
                <Form onSubmit={this.handleSubmit}>
                    <FormItem>
                        {getFieldDecorator('frequency', {
                            rules: [{ required: true, message: 'Select time please!' }],
                            initialValue: frequency == null ? 'Select the frequency' : frequency,
                        })(
                            <Select
                                showSearch
                                style={{ width: 200 }}
                                placeholder="Select the frequency"
                                optionFilterProp="children"
                                onChange={this.handleChange}
                                filterOption={
                                    (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {frequencyOptions}
                            </Select>,
                        )}
                    </FormItem>

                    { getFieldValue('frequency') === 'Select the frequency'
                        ? (
                            <Row type="flex" justify="center" style={{ marginTop: '10%' }}>
                                <Col span={12} pull={6}>
                                    <FormItem>
                                        <Button type="primary" onClick={() => changeActiveKey('2')}>To Prev</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        )
                        : null
                    }

                    { getFieldValue('frequency') !== 0 && getFieldValue('frequency') !== 'Select the frequency' && getFieldValue('frequency') !== 30
                        ? (
                            <Row type="flex" justify="center" style={{ marginTop: '10%' }}>
                                <Col span={12}>
                                    <FormItem>
                                        <Button type="primary" onClick={() => changeActiveKey('2')}>To Prev</Button>
                                    </FormItem>
                                </Col>

                                <Col span={12}>
                                    <FormItem>
                                        <Button type="primary" htmlType="submit">To Next</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        )
                        : null
                    }

                </Form>

                { getFieldValue('frequency') === 0
                    ? (
                        <Custom
                            data={data}
                            changeActiveKey={changeActiveKey}
                            handleDoseFrequency={handleDoseFrequency}
                        />
                    )
                    : null
                }

                { getFieldValue('frequency') === 30
                    ? (
                        <CustomMonth
                            data={data}
                            changeActiveKey={changeActiveKey}
                            handleDoseFrequency={handleDoseFrequency}
                        />
                    )
                    : null
                }

            </div>
        );
    }
}

const DoseFrequency = Form.create()(UnwrappedDoseFrequency);

export default DoseFrequency;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/TabsComponents/DoseFrequency.js